import { db, storage } from "../firebase-config";
import { collection, getDocs, query, addDoc, onSnapshot, where, doc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

export const getAllInvoices = async (organization) => {
    try {
        const invoicesCollectionRef = collection(db, "organizations", organization, "invoices");
        const q = query(invoicesCollectionRef); // You can add conditions to your query if needed
        const querySnapshot = await getDocs(q);
        const invoices = [];
        querySnapshot.forEach((doc) => {
            invoices.push({ id: doc.id, ...doc.data() });
        });
        return invoices;
    } catch (error) {
        console.error("Error getting documents: ", error);
        alert(error);
    }
};

export const getCustomerInvoices = async (organization, customerId) => {
    try {
        const invoicesCollectionRef = collection(db, "organizations", organization, "invoices");
        const q = query(
            invoicesCollectionRef,
            where("customer_id", "==", customerId),
            where("finalized", "==", true),
        );
        const data = await getDocs(q);
        const invoices = [];
        data.forEach((doc) => {
            invoices.push({ id: doc.id, ...doc.data() });
        });
        return invoices;
    } catch (error) {
        return([])
    }
};

// Add a new invoice document
export const addInvoice = async (organization, openAIData, url) => {
    try {
        const { order_details } = openAIData;
        const { date_order_placed, ...restOfOrderDetails } = order_details;
        const dateOrderPlacedTimestamp = new Date(date_order_placed * 100);

        await addDoc(collection(db, "organizations", organization, "invoices"), {
            ...restOfOrderDetails,
            date_order_placed: dateOrderPlacedTimestamp,
            url: url,
            received: false
        });

        return { success: true, error: null };
    } catch (error) {
        console.error("Error adding invoice:", error);
        return { success: false, error: error.message || 'Failed to add invoice' };
    }
};

// Upload an invoice file and return its download URL
export const uploadInvoice = async (organization, file) => {
    try {
        const storageRef = ref(storage, `/organizations/${organization}/invoices/${file.name}`);
        const snapshot = await uploadBytes(storageRef, file);
        const downloadURL = await getDownloadURL(snapshot.ref);
        return { success: true, data: downloadURL, error: null };
    } catch (error) {
        return { success: false, data: null, error: error.message || 'Failed to upload invoice file' };
    }
};

//Snapshot Listeners
export const organizationInvoiceSnapshotListener = (organization, onInvoiceUpdate) => {
    const invoiceQuery = query(collection(db, "organizations", organization, "invoices"))
    const unsubscribe = onSnapshot(invoiceQuery, (querySnapshot) => {
        const invoiceItems = [];
        querySnapshot.forEach((doc) => {
          invoiceItems.push({ id: doc.id, ...doc.data() });
        });
        onInvoiceUpdate(invoiceItems);
    })
    return () => unsubscribe()
}

export const invoiceSnapshotListener = (organization, invoiceId, onInvoiceUpdate) => {
    const invoiceRef = doc(db, "organizations", organization, "invoices", invoiceId)
    const unsubscribe = onSnapshot(invoiceRef, (docSnapshot) => {
        if (docSnapshot.exists()) {
            onInvoiceUpdate({ id: docSnapshot.id, ...docSnapshot.data() });
        } else {
            onInvoiceUpdate(null);
        }
    });
    return unsubscribe;
}

export const invoiceRefundSnapshotListener = (organization, invoiceId, onRefundUpdate) => {
    const refundCollectionRef = collection(db, "organizations", organization, "invoices", invoiceId, "refunds");

    // Listen to the entire collection (not a single document)
    const unsubscribe = onSnapshot(refundCollectionRef, (snapshot) => {
        if (!snapshot.empty) {
            const refundData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            onRefundUpdate(refundData);
        } else {
            onRefundUpdate([]);
        }
    });

    return unsubscribe;
}

export const fetchInvoicesForMonth = (organizationId, monthStart, monthEnd) => {
    const stubInvoices = [
      { id: 'inv001', number: 'INV-2024-001', vendor: 'Vendor A', amount: '$1,200', status: 'Pending' },
      { id: 'inv002', number: 'INV-2024-002', vendor: 'Vendor B', amount: '$700', status: 'Paid' },
      { id: 'inv003', number: 'INV-2024-003', vendor: 'Vendor C', amount: '$2,500', status: 'Pending' },
      { id: 'inv004', number: 'INV-2024-004', vendor: 'Vendor D', amount: '$1,000', status: 'Overdue' },
    ];
  
    return stubInvoices
  };
  